type Props = {
  busy: boolean;
  onConnect: () => void;
  connectedEmail?: string;
  savedEmail?: string;
  requireSave?: boolean;
  canConnect?: boolean;
};

export function GoogleDrivePanel({
  busy,
  onConnect,
  connectedEmail = '',
  savedEmail = '',
  requireSave = false,
  canConnect = true,
}: Props) {
  const linked = Boolean(connectedEmail || savedEmail);
  const buttonLabel = linked ? 'Change Google Drive' : 'Connect with Google Drive';
  const shownEmail = connectedEmail || savedEmail;

  return (
    <div className="mt-4 rounded-lg border p-4">
      <p className="text-sm font-medium">Google Drive</p>
      <p className="mt-1 text-sm text-muted-foreground">
        {shownEmail ? (
          <>
            Reports will be stored in <span className="font-medium text-foreground">{shownEmail}</span>.
            A folder named CloudTelephony Reports is used there. This user chooses one report schedule from their profile.
          </>
        ) : (
          <>
            Connect the Google account that should store this user&apos;s reports.
            A folder named CloudTelephony Reports is created there. They choose one report schedule from their profile.
          </>
        )}
      </p>
      {canConnect && (
        <button
          type="button"
          onClick={onConnect}
          disabled={busy}
          className="mt-3 inline-flex items-center gap-3 rounded-md border bg-white px-4 py-2 text-sm font-medium text-slate-800 shadow-sm hover:bg-slate-50 disabled:opacity-60"
        >
          <GoogleDriveIcon />
          {busy ? 'Waiting for Google…' : buttonLabel}
        </button>
      )}
      {connectedEmail ? (
        <p className="mt-2 text-sm text-emerald-700">
          Connected as {connectedEmail}.
          {requireSave
            ? savedEmail && savedEmail !== connectedEmail
              ? ` Save the user to replace ${savedEmail}.`
              : ' Save the user to keep this Drive on the account.'
            : ' You can create the user now.'}
        </p>
      ) : savedEmail ? (
        <p className="mt-2 text-sm text-emerald-700">Linked as {savedEmail}</p>
      ) : null}
    </div>
  );
}

export function GoogleDriveIcon() {
  return (
    <svg width="22" height="20" viewBox="0 0 87.3 78" aria-hidden="true">
      <path d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z" fill="#0066da" />
      <path d="m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0-1.2 4.5h27.5z" fill="#00ac47" />
      <path d="m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z" fill="#ea4335" />
      <path d="m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z" fill="#00832d" />
      <path d="m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z" fill="#2684fc" />
      <path d="m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z" fill="#ffba00" />
    </svg>
  );
}
